import CalendarIcon from "../../assets/images/calendar.svg";
import flight from "../../assets/images/flight.svg";
import style from "./RentalLocation.module.scss";
const RentalLocation = ({
  pickupDate,
  pickupTime,
  locations = [],
}: {
  pickupDate: string;
  pickupTime: string;
  locations: string[];
}) => {
  return (
    <div className={style.rentalLocation}>
      <h4>Car Pickup location</h4>

      <div className={`${style.rentalLocation__wrap} flex-wrap`}>
        <div className={style.rentalLocation__col}>
          <h5>Pick-up</h5>

          <div className={`${style.rentalLocation__item} flex`}>
            <img src={CalendarIcon} alt="Calendar" />
            <p>
              {pickupDate}, {pickupTime}.
            </p>
          </div>
          <div className={`${style.rentalLocation__item} flex`}>
            <img src={flight} alt="Calendar" />
            <p>
              {locations.map((location: string) => {
                return (
                  <>
                    {location}
                    <br />
                  </>
                );
              })}
            </p>

            {/* <p>
              DEL Airport <br />
              Airline Flight Dtls Mandatory Meet And Greet Service, New Delhi,
              IND 110 037
            </p> */}
          </div>
          {/* <div className={`${style.rentalLocation__item} flex`}>
            <img src={clock} alt="clock" />
            <p>
              Hours of operation
              <br />
              12:01 a.m. - 11:59 p.m.
            </p>
          </div> */}
          {/* <div className={`${style.rentalLocation__item} flex`}>
            <img src={car} alt="car" />
            <p>
              Counter and car in terminal
              <br />
              Rental car counter and car in the airport.
            </p>
          </div> */}
        </div>
        {/* <div className={style.rentalLocation__col}>
          <h5>Drop-off</h5>

          <div className={`${style.rentalLocation__item} flex`}>
            <img src={CalendarIcon} alt="Calendar" />
            <p>Mon, Feb 5, 10:30 a.m.</p>
          </div>

          <div className={`${style.rentalLocation__item} flex`}>
            <img src={marker} alt="marker" />
            <p>
              Hours of operation
              <br />
              7:00 a.m. - 10:00 p.m.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};
export default RentalLocation;
